import React, { useRef, useState, useEffect } from 'react'
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col";
import DatePicker from "react-datepicker";
import $ from "jquery";
import "react-datepicker/dist/react-datepicker.css";

const InputField = ({ startDate, setStartDate, startTime, setStartTime, fieldClass, name, required, grpmd }) => {
    const [isEditing, setEditing] = useState(false);
    const inputRef = useRef();

    return (
        <>

            <Form.Group as={Col} md={grpmd} className={"form-wrap "}>
                <label htmlFor="date" className="form-label">
                    Preferred Date
                </label>
                <DatePicker
                    selected={startDate}
                    onChange={date => setStartDate(date)}
                    minDate={new Date()}
                    placeholderText={`Select your preferred date`}
                    dateFormat="MMMM d, yyyy"
                    className={fieldClass}
                    required={required}
                    autocomplete="off"
                    name={name}
                    autoComplete={'' + Math.random()}
                    // onChange={handlechange}
                    value={startDate}

                />
            </Form.Group>
            <Form.Group as={Col} md={grpmd} className={"form-wrap "}>
                <label htmlFor="time" className="form-label">
                    Preferred Time
                </label>
                <DatePicker
                    showTimeSelect
                    minDate={new Date()}
                    placeholderText={`Select your preferred time`}
                    dateFormat="h:mm aa"
                    className={fieldClass}
                    required={required}
                    onChange={(date) => setStartTime(date)}
                    showTimeSelectOnly
                    autocomplete="off"
                    name='preferred_time'
                    autoComplete={'' + Math.random()}
                    value={startTime}
                    selected={startTime}

                />
            </Form.Group>

        </>
    );
};
export default InputField;